import type { PaletteMode } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { readThemeHint, resolveThemeHint, themeKeyToHint } from 'themes/themeHint';
import { getIsThemeKeyLoaded, getThemeKey } from 'themes/themesSelectors';
import useSystemColorScheme from './useSystemColorScheme';

// Until the theme key loads, follows the last saved appearance, else the system setting.
const useThemeMode = (): PaletteMode => {
  const themeKey = useSelector(getThemeKey);
  const themeKeyLoaded = useSelector(getIsThemeKeyLoaded);
  const [savedHint] = useState(readThemeHint);
  const systemColorScheme = useSystemColorScheme();
  const hint = themeKeyLoaded ? themeKeyToHint(themeKey) : (savedHint ?? 'system');
  return resolveThemeHint(hint, systemColorScheme);
};

export default useThemeMode;
